




















import { Component, Vue, Prop } from 'vue-property-decorator'
import { ProblemTagSummaryData, ProblemTagSummaries } from '@/models/api/common/SummaryResultTypes.vue'
import ByProblemTagRatio from '@/components/common/organisms/ByProblemTagRatio.vue'

@Component({
  components: { ByProblemTagRatio },
})
export default class StudyResultTable extends Vue {
  @Prop()
  problemTagsBySubject!: ProblemTagSummaryData
  @Prop({ default: false })
  isStudyModeRecommend!: boolean

  private get comvertedSubjectName(): string {
    return this.problemTagsBySubject.subjectName.replace('/', '／')
  }
  private get tableColspan(): number {
    return this.problemTagsBySubject.problemTags.length + 1
  }

  private totalAverageScore(problemTag: ProblemTagSummaries): number | null {
    return this.isStudyModeRecommend ? problemTag.totalAdjustAverageScore : problemTag.totalAverageScore
  }

  private branchAverageScore(problemTag: ProblemTagSummaries): number | null {
    if (this.isStudyModeRecommend) {
      return problemTag.branchAdjustAverageScore !== undefined ? problemTag.branchAdjustAverageScore : null
    } else {
      return problemTag.branchAverageScore !== undefined ? problemTag.branchAverageScore : null
    }
  }

  private maxScore(problemTag: ProblemTagSummaries): number {
    if (this.isStudyModeRecommend) return problemTag.maxAdjustScore || 0
    else return problemTag.maxScore || 0
  }

  private scoreLabelPush(score: number): string {
    const convertScore = this.convertValue(score)
    return this.isStudyModeRecommend ? convertScore : convertScore + '点'
  }

  private convertValue(value: number): string {
    return value !== null ? value.toFixed(1) : '—'
  }

  private get subjectStyle(): { [key: string]: string } {
    return {
      '--background': `var(--color-subject-${this.problemTagsBySubject.subjectCode})`,
    }
  }
}
